var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-drawer",
    {
      attrs: {
        visible: _vm.visible,
        "before-close": _vm.handleClose,
        "append-to-body": false,
        "custom-class": "project-drawer",
        size: "250px",
        direction: "ltr",
      },
    },
    [
      _c("el-input", {
        attrs: { placeholder: "请输入内容" },
        model: {
          value: _vm.searchInput,
          callback: function ($$v) {
            _vm.searchInput = $$v
          },
          expression: "searchInput",
        },
      }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "section" },
        [
          _c("section-head", {
            attrs: { "icon-class": "wk wk-label", label: "标签看板" },
          }),
          _vm._v(" "),
          _c(
            "draggable",
            {
              attrs: {
                options: {
                  forceFallback: false,
                  disabled: _vm.searchInput.length > 0,
                },
              },
              on: { end: _vm.moveItem },
              model: {
                value: _vm.list,
                callback: function ($$v) {
                  _vm.list = $$v
                },
                expression: "list",
              },
            },
            _vm._l(_vm.showList, function (item, index) {
              return _c("project-cell", {
                key: index,
                attrs: {
                  drag: _vm.searchInput.length == 0,
                  label: item.name,
                  "icon-color": item.color,
                  collect: false,
                  "icon-class": "wk wk-label",
                },
                nativeOn: {
                  click: function ($event) {
                    return _vm.enterDetail(item)
                  },
                },
              })
            }),
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }